import { DesignersDetailsStore, DesignersDetailsActions } from './types';

export const defaultState: DesignersDetailsStore = {
  error: null,
  isLoading: false,
  isLoaded: false,
  errorProducts: null,
  isLoadingProducts: false,
  isLoadedProducts: false,
  designer: null,
  designers: [],
  articles: [],
  products: [],
};

const reducer = (
  state: DesignersDetailsStore = defaultState,
  action: { type: DesignersDetailsActions; payload?: any }
): DesignersDetailsStore => {
  switch (action.type) {
    case DesignersDetailsActions.FetchDetailsBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null,
      };
    }
    case DesignersDetailsActions.FetchDetailsError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case DesignersDetailsActions.FetchDetailsSuccess: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: null,
        ...action.payload,
      };
    }

    //Fetch products
    case DesignersDetailsActions.FetchDetailsProductsBegin: {
      return {
        ...state,
        isLoadingProducts: true,
        isLoadedProducts: false,
        errorProducts: null,
      };
    }
    case DesignersDetailsActions.FetchDetailsProductsError: {
      return {
        ...state,
        isLoadingProducts: false,
        isLoadedProducts: true,
        errorProducts: action.payload,
      };
    }
    case DesignersDetailsActions.FetchDetailsProductsSuccess: {
      return {
        ...state,
        isLoadingProducts: false,
        isLoadedProducts: true,
        errorProducts: null,
        products: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
